import { getI18nText } from '@/i18n';

export default {
	name: 'zhaonax-school-management',
	path: '/zhaonax-school-management',
	redirect: '/zhaonax-school-management/school-manage',
	meta: {
		title: getI18nText('学校管理'),
		icon: ''
	},
	children: [
		{
			name: 'zhaonax-school-management-children',
			path: '/zhaonax-school-management/school-manage',
			fullPath: '/zhaonax-school-management/school-manage',
			meta: {
				title: getI18nText('学校管理'),
				icon: ''
			},
			component: () =>
				import(/* webpackChunkName: "school-manage" */ '@/views/zhaonax-school-management/school-manage')
		}
	]
};
